import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0db721b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["poster", "src"]
const _hoisted_2 = {
  key: 0,
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<rect width=\"40\" height=\"40\" fill=\"#C4C4C4\" fill-opacity=\"0.01\" data-v-0db721b1></rect><path d=\"M32.809 33.8459C36.1518 30.1139 38.1857 25.1833 38.1857 19.7766C38.1857 14.6046 36.3245 9.86829 33.2369 6.20001L31.3882 8.04868C34.0094 11.2405 35.5819 15.3253 35.5819 19.7766C35.5819 24.4626 33.8392 28.7424 30.965 32.0019L32.809 33.8459Z\" fill=\"white\" data-v-0db721b1></path><path d=\"M29.0751 30.112C31.353 27.2887 32.7178 23.6925 32.7178 19.7766C32.7178 16.0967 31.5125 12.6992 29.4769 9.96L27.6122 11.8247C29.1886 14.0744 30.114 16.8169 30.114 19.7766C30.114 22.973 29.0347 25.9161 27.2216 28.2585L29.0751 30.112Z\" fill=\"white\" data-v-0db721b1></path><path d=\"M25.1994 26.2363C26.4905 24.4116 27.2498 22.1832 27.2498 19.7766C27.2498 17.6082 26.6333 15.5843 25.5667 13.8701L23.6603 15.7766C24.29 16.9716 24.6461 18.3327 24.6461 19.7766C24.6461 21.4612 24.1614 23.0331 23.3231 24.36L25.1994 26.2363Z\" fill=\"white\" data-v-0db721b1></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.19999 14.455C3.75817 14.455 3.39999 14.8132 3.39999 15.255V24.855C3.39999 25.2968 3.75817 25.655 4.19999 25.655H11.6399L18.063 32.0781C18.2918 32.3068 18.6359 32.3753 18.9348 32.2515C19.2338 32.1276 19.4287 31.8359 19.4287 31.5124V8.655C19.4287 8.33143 19.2338 8.03973 18.9348 7.9159C18.6359 7.79208 18.2918 7.86052 18.063 8.08932L11.6973 14.455H4.19999ZM18.6287 31.5124L11.9713 24.855H4.2V15.255H4.19999V24.855H11.9713L18.6287 31.5124Z\" fill=\"white\" data-v-0db721b1></path>", 5)
const _hoisted_8 = [
  _hoisted_3
]
const _hoisted_9 = {
  key: 1,
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  width: "40",
  height: "40",
  fill: "#C4C4C4",
  "fill-opacity": "0.01"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M36.5154 16.1154L34.8184 14.4184L31 18.2368L27.1816 14.4184L25.4846 16.1154L29.3029 19.9338L25.4846 23.7522L27.1816 25.4492L31 21.6309L34.8184 25.4492L36.5154 23.7522L32.6971 19.9338L36.5154 16.1154Z",
  fill: "white"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.19999 14.4C3.75817 14.4 3.39999 14.7582 3.39999 15.2V24.8C3.39999 25.2419 3.75817 25.6 4.19999 25.6H11.6399L18.063 32.0231C18.2918 32.2519 18.6359 32.3203 18.9348 32.1965C19.2338 32.0727 19.4287 31.781 19.4287 31.4574V8.60003C19.4287 8.27646 19.2338 7.98475 18.9348 7.86092C18.6359 7.7371 18.2918 7.80554 18.063 8.03434L11.6973 14.4H4.19999ZM4.19999 24.8L4.2 15.2H12.0287L18.6287 8.60004V8.60003L12.0287 15.2H4.19999V24.8Z",
  fill: "white"
}, null, -1))
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]

import { inject, ref, watch } from 'vue';

interface LazyVideoProps {
  src: string;
  poster: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LazyVideo',
  props: {
    src: null,
    poster: null
  },
  setup(__props: any) {



const { onLoad, onError }: any = inject('onLoadOnError');
const show = ref(false);
const muted = ref(true);
const video = ref<HTMLVideoElement | null>(null);
const showAudioButton = ref(false);

watch(video, () => {
  if (video.value) {
    video.value.load();
  }
});

watch(show, () => {
  showAudioButton.value = hasAudio();
  if (video.value) {
    video.value.play();
    onLoad();
  }
});

// ensure two-way sync
const onVideoVolumeChanged = () => {
  if (video.value) {
    muted.value = video.value.muted;
  }
};

const toggleSound = () => {
  if (video.value) {
    video.value.muted = !video.value.muted;
    muted.value = !muted.value;
  }
};

/**
 * @see https://stackoverflow.com/a/31022391
 */
const hasAudio = (): boolean => {
  if (video.value) {
    const vid = video.value;
    // note: double !! to cast to boolean
    return (
      // @ts-ignore: mozHasAudio exists on mozilla browsers on HTMLMediaElement
      vid.mozHasAudio ||
      // @ts-ignore: webkitAudioDecodedByteCount exists (except on Safari) on HTMLMediaElement
      !!JSON.parse(vid.webkitAudioDecodedByteCount || null) ||
      // @ts-ignore: audioTracks exists on HTMLMediaElement
      !!JSON.parse(vid.audioTracks?.length || null) ||
      false
    );
  }

  // default to no audio
  return false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["manifold m-lazy-media lazy-video", { show: show.value }])
  }, [
    _createElementVNode("video", {
      ref_key: "video",
      ref: video,
      poster: __props.poster,
      src: __props.src,
      autoplay: "",
      loop: "",
      muted: "",
      controls: "",
      "webkit-playsinline": "",
      playsinline: "",
      disablePictureInPicture: "",
      disableRemotePlayback: "",
      onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onError) && _unref(onError)(...args))),
      onCanplaythrough: _cache[1] || (_cache[1] = ($event: any) => (show.value = true)),
      onLoadeddata: _cache[2] || (_cache[2] = ($event: any) => (show.value = true)),
      onVolumechange: onVideoVolumeChanged
    }, null, 40, _hoisted_1),
    (showAudioButton.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: toggleSound
        }, [
          (!muted.value)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_8))
            : (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_13))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})